import getAnneeSemaine, { getDateByJourAnneeSemaine } from '@/services/general/getAnneeSemaine';
import getFacesReseauAsync from '@/services/reseauxTempo/getFaces';

async function preSauvegardeTempoInitializer(reseauTempo) {
  if (reseauTempo.listeFaces &&
    reseauTempo.listeFaces.length) {
    return;
  }

  const dateDebut = getDateByJourAnneeSemaine(
    reseauTempo.jourDepart,
    reseauTempo.extensionOpportunite.annee,
    reseauTempo.extensionOpportunite.annee).format('YYYYMMDD');
  const query = {
    params: {
      dateVisualisation: dateDebut,
      anneeSemaine: getAnneeSemaine(
        reseauTempo.extensionOpportunite.annee,
        reseauTempo.extensionOpportunite.semaine,
      ),
      jourDepart: reseauTempo.jourDepart,
      societeId: reseauTempo.socCode,
    },
  };
  reseauTempo.listeFaces = await getFacesReseauAsync(reseauTempo.num, query);
}

export default async function preSauvegardeInitializer(produits) {
  const promesses = [];
  produits.reseauxTempo.forEach((reseauTempo) => {
    promesses.push(preSauvegardeTempoInitializer(reseauTempo));
  });
  await Promise.all(promesses);
}



// WEBPACK FOOTER //
// ./src/services/panier/preSauvegardeInitializer.js